import React, { Component, ErrorInfo } from 'react'
import {
  ComcastErrorType,
  triggerSentryError,
} from '../../../../shared/helpers'
import ErrorScreen from '../../screens/ErrorScreen'
import { setLoadingState } from '../../lib/ui'
import { store } from '../../store'
import { SentryBoundaryProps, SentryBoundaryState } from './types'

class SentryBoundary extends Component<
  SentryBoundaryProps,
  SentryBoundaryState
> {
  constructor(props: SentryBoundaryProps) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    triggerSentryError(
      `'App.js ${error.name}`,
      'App.js',
      {
        errorMessage: error.message ?? 'Undefined error message (default)',
        errorLocation: 'App (SentryBoundary) componentDidCatch',
        errorInfo,
        errorType: ComcastErrorType.other,
      },
      true
    )

    setLoadingState(false)
    store.dispatch({
      type: 'TRIGGER_ERROR',
      payload: {
        status: 'fatal',
        content: {
          errorPath: undefined,
        },
        codeBaseLocation: 'App - SentryBoundary',
      },
    })

    // @ts-ignore - Global variable set by webpack
    if (COMPILING_FOR_COMCASTX1) {
      import('@firebolt-js/sdk').then((firebolt) => {
        const Lifecycle = firebolt?.Lifecycle
        Lifecycle.close(Lifecycle.CloseReason.ERROR)
      })
    }

    this.setState({ error })
  }

  render() {
    const { error } = this.state
    const { children } = this.props

    if (error) {
      return <ErrorScreen />
    }

    return children
  }
}

export default SentryBoundary
